import { SAvatar } from './Avatar.styles';
import { AvatarProps } from './Avatar.types';

export const Avatar = ({ ...props }: AvatarProps) => {
  return <SAvatar {...props} />;
};
